/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：806
 */

module.exports = {
  container: "SaveFailedDialog_container__2RvNY",
  saveBtn: "SaveFailedDialog_saveBtn__13Loc",
  cancelBtn: "SaveFailedDialog_cancelBtn__3UPNy",
  retryBtn: "SaveFailedDialog_retryBtn__iKdJm"
}
